import { Table } from 'antd';
import { ColumnsType, TablePaginationConfig } from 'antd/es/table';
import { observer } from 'mobx-react';
import React, { useEffect } from "react";
import Subjects from '../../models/subjects';
import { useStore } from '../../stores/root-store';
import TaskItemStore from "../../stores/task/task-item";
import TaskListStore from '../../stores/task/task-list';
import TaskItem from './task-item';
import './task-table.css';

interface Task {
  number: number;
  data: TaskItemStore;
  subject: Subjects;
}

export interface TaskListProps {
  taskList: TaskListStore;
}

function taskItemRender(task: TaskItemStore) {
  return (
    <TaskItem key={task.data.id} {...{ taskProps: task, subject: task.subject }} />
  );
}

const columns: ColumnsType<Task> = [
  {
    title: 'Номер',
    dataIndex: 'number',
    key: 'number',
    align: 'center',
    width: '5%'
  },
  {
    title: 'Задача',
    dataIndex: 'data',
    key: 'task',
    width: '95%',
    align: 'left',
    render: taskItemRender
  }
];

const TaskTable: React.FC<{ subject: Subjects }> = ({ subject }) => {

  const { subjectStores, authStore } = useStore();
  const taskList = subjectStores[subject].taskList;
  const newTicket = subjectStores[subject].newTicket;
  const taskFilter = subjectStores[subject].taskFilter;

  function getEnumerateTasks(tasks: TaskItemStore[]): Task[] {
    return tasks.map((task, indx) => {
      return { number: indx + 1 + (taskList.page - 1) * taskList.pageSize, data: task, key: task.data.id, subject: subject } as Task
    });
  }

  useEffect(() => {

    if (authStore.isAuthenticated) {
      newTicket.loadFull();
      taskList.initTask();
    }
  }, [newTicket, taskList, authStore.isAuthenticated]
  );

  return (
    <div className="task-table">
      <Table
        columns={columns}
        dataSource={getEnumerateTasks(taskList.data)}
        pagination={{
          position: ["topRight", "bottomRight"],
          total: taskList.totalCount,
          current: taskList.page,
          pageSize: taskList.pageSize,
          onChange: (page, pageSize) => {
            taskList.filterTask(taskFilter.getCriteria, page, pageSize);
          }
        }}
        loading={taskList.loading}
      />
    </div>
  );
};

export default observer(TaskTable);